/**
 * 广告金币展示：与 App / Java RewardDisplay 同一规则。
 * 真实金币（eCPM 截断 2 位）× 用户收益占比/100，再截断 2 位。
 * 记录无占比快照按 100，历史显示不变。
 */
export function formatReward(v, ratio) {
  const realCoins = truncScale(toPlainString(v), 2)
  const r = normalizeRatio(ratio)
  if (r === 100) {
    return realCoins
  }
  return applyRatio(realCoins, r)
}

export function formatRewardLabel(v, ratio) {
  return `${formatReward(v, ratio)} 金币`
}

export function normalizeRatio(ratio) {
  if (ratio == null || ratio === '') {
    return 100
  }
  const n = Number(ratio)
  if (!Number.isFinite(n) || n < 0) {
    return 100
  }
  return Math.trunc(n)
}

/** 金币字符串（已 2 位）× 占比/100，向 0 截断到 2 位。 */
function applyRatio(coinsStr, ratioPercent) {
  let s = truncScale(toPlainString(coinsStr), 2)
  const neg = s.startsWith('-')
  if (neg) {
    s = s.slice(1)
  }
  const [intPart, frac = '00'] = s.split('.')
  const cents = Number(intPart || '0') * 100 + Number((frac + '00').slice(0, 2))
  // 向 0 截断
  const scaled = Math.trunc((cents * ratioPercent) / 100)
  const abs = Math.abs(scaled)
  const ip = Math.floor(abs / 100)
  const fp = String(abs % 100).padStart(2, '0')
  return `${neg ? '-' : ''}${ip}.${fp}`
}

function toPlainString(v) {
  if (v == null || v === '') {
    return '0'
  }
  if (typeof v === 'number') {
    if (!Number.isFinite(v)) {
      return '0'
    }
    return v.toLocaleString('en-US', {
      useGrouping: false,
      maximumFractionDigits: 20
    })
  }
  const s = String(v).trim()
  if (!s || s === 'null' || s === 'undefined') {
    return '0'
  }
  if (/[eE]/.test(s)) {
    const n = Number(s)
    if (!Number.isFinite(n)) {
      return '0'
    }
    return n.toLocaleString('en-US', {
      useGrouping: false,
      maximumFractionDigits: 20
    })
  }
  return s
}

function truncScale(raw, scale) {
  let s = toPlainString(raw)
  const neg = s.startsWith('-')
  if (neg) {
    s = s.slice(1)
  }
  if (!/^\d+(\.\d+)?$/.test(s)) {
    return (0).toFixed(scale)
  }
  let [intPart, frac = ''] = s.split('.')
  intPart = (intPart || '0').replace(/^0+(?=\d)/, '') || '0'
  frac = (frac + '0'.repeat(scale)).slice(0, scale)
  return `${neg ? '-' : ''}${intPart}.${frac}`
}
